import { useState } from 'react';

export default function useAppProvider() {
  const getLocalStorageItem = (key) => {
    const storage = localStorage;

    return storage.getItem(key);
  };

  const initialData = {
    accessToken: getLocalStorageItem('access_token'),
    refreshToken: getLocalStorageItem('refresh_token'),
    accessTokenDate: getLocalStorageItem('access_token_date'),
    accessTokenExpireIn: getLocalStorageItem('access_token_expires_in')
  };
  const [localStorageData, setlocalStorageData] = useState(initialData);

  const removeLocalStorageItem = (key) => {
    const storage = localStorage;

    storage.removeItem(key);

    setlocalStorageData({
      ...localStorageData,
      [key]: undefined
    });
  };
  const setLocalStorageItem = (key, value) => {
    setlocalStorageData({
      ...localStorageData,
      [key]: value
    });
    const storage = localStorage;

    storage.setItem(key, value);
  };

  return {
    getLocalStorageItem,
    setLocalStorageItem,
    localStorageData,
    removeLocalStorageItem
  };
}
